import * as React from 'react';
import { QuarterPicker as Content } from '~/UI/DatePicker';

export const QuarterPicker: React.FunctionComponent<
	React.PropsWithChildren<{
		allowedRange?: [Date | null, Date | null];
		disabled?: boolean;
		value: Date | null;
		onSelect(date: Date): void;
	}>
> = ({ allowedRange = [null, null], disabled, value, onSelect }) => {
	const mappedRange: [Date | null, Date | null] = React.useMemo(() => {
		const fromDate = allowedRange[0] !== null ? new Date(allowedRange[0]) : null;
		const toDate = allowedRange[1] !== null ? new Date(allowedRange[1]) : null;

		if (fromDate !== null) {
			fromDate.setDate(1);
			fromDate.setMonth(fromDate.getMonth() - 3);
		}
		if (toDate !== null) {
			toDate.setDate(1);
			toDate.setMonth(toDate.getMonth() - 3);
		}
		return [fromDate, toDate];
	}, [allowedRange]);

	const date = React.useMemo(() => {
		if (value === null) {
			return null;
		}
		const date = new Date(value);
		date.setMonth(date.getMonth() - 3);
		return date;
	}, [value]);

	const select = (date: Date) => {
		const alteredDate = new Date(date);
		alteredDate.setMonth(alteredDate.getMonth() + 3);
		onSelect(alteredDate);
	};

	return <Content allowedRange={mappedRange} disabled={disabled} value={date} onSelect={select} />;
};

QuarterPicker.displayName = 'ExchangeRate.QuarterPicker';
